module.exports = __webpack_public_path__ + "img/pnu_read_gallery0.b8e21ba2.jpg";